@let s = steps();

<cmi-step-panel
  [title]="'dossierSearch.title' | translate"
  [summary]="s.selectedDossierSummary()"
  [placeholder]="'dossierSearch.stepHint' | translate">
  <cmi-dossier-search
    [term]="s.searchTerm()"
    (termChange)="s.searchTerm.set($event)"
    [selectedGuid]="s.selectedDossier()?.guid ?? null"
    [proposals]="s.proposals.value()"
    [proposalsLoading]="s.proposals.isLoading()"
    (dossierSelect)="s.selectDossier($event)" />
</cmi-step-panel>

@if (s.selectedDossier()) {
  <cmi-step-panel
    [title]="'dossierDetail.title' | translate"
    [summary]="
      s.selectedFolderPath() ?? (s.rootSelected() ? ('dossierDetail.root' | translate) : null)
    "
    [placeholder]="'dossierDetail.rootHint' | translate">
    @if (s.dossierDetail.isLoading()) {
      <div class="flex justify-center py-2">
        <cmi-loading-spinner />
      </div>
    } @else if (s.dossierDetail.error()) {
      <cmi-notification
        mode="error"
        [message]="'dossierDetail.error' | translate"
        [actionLabel]="'dossierDetail.retry' | translate"
        (actionClick)="s.dossierDetail.reload()" />
    } @else if (s.dossierDetail.hasValue()) {
      <cmi-folder-tree
        [folders]="s.folderTree()"
        [selectedGuid]="s.selectedTreeGuid()"
        [startOpen]="true"
        [newFolder]="s.newFolder()"
        [canCreate]="s.canCreateFolder()"
        (folderSelect)="s.selectFolder($event)"
        (newFolderStart)="s.startNewFolder($event)"
        (newFolderTitleChange)="s.changeNewFolderTitle($event)"
        (newFolderAdd)="s.planNewFolder()"
        (newFolderDiscard)="s.discardNewFolder()"
        (plannedFolderRemove)="s.removePlannedFolder()" />
    }
  </cmi-step-panel>

  <cmi-step-panel
    [title]="'documentFields.title' | translate"
    [placeholder]="'documentFields.stepHint' | translate">
    @if (s.fieldConfig.isLoading()) {
      <div class="flex justify-center py-2">
        <cmi-loading-spinner />
      </div>
    } @else if (s.fieldConfig.error()) {
      <cmi-notification
        mode="error"
        [message]="'documentFields.error' | translate"
        [actionLabel]="'documentFields.retry' | translate"
        (actionClick)="s.fieldConfig.reload()" />
    } @else if (s.fieldConfig.value(); as loaded) {
      @if (loaded.form.sections.length) {
        <cmi-document-fields
          [config]="loaded.form"
          [values]="s.fieldValues()"
          [locked]="loaded.locked"
          [prefill]="loaded.prefill"
          (valueChange)="s.changeFieldValue($event)" />
      } @else {
        <cmi-notification mode="info" [message]="'documentFields.empty' | translate" />
      }
    }
  </cmi-step-panel>
}
